import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Button, Form, Input, message, Checkbox } from 'antd';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'hooks';
import qs from 'query-string';
import Loading from 'components/molecules/Loading';
import { BlackLogo } from 'components/molecules';
import { formValidation } from 'utils/form-utils';
import './index.scss';
import { MSG } from 'commons/constants';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

const cx = classNames.bind('./index.scss');

export interface LoginProps {}

const Login = ({}: React.PropsWithChildren<LoginProps>): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const [form] = Form.useForm();
  const { login, isLoading } = useAuth();
  const location = useLocation();

  /* ======================================================
   * events
   * ====================================================== */
  const onClickLogin = () => {
    login({ email: form.getFieldValue('id'), password: form.getFieldValue('pw') });
  };

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    const error = qs.parse(location.search).error;
    if (error === 'loginDupl') message.error(MSG.ERROR_DUPLICATED_LOGIN, 1);
  }, []);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      {isLoading ? (
        <Loading size="large" />
      ) : (
        <div className={cx('loginPage')}>
          <div className={cx('loginContainer')}>
            <div style={{display:"flex", justifyContent:"space-between"}}>
              <BlackLogo />
              <h3 style={{color:"#039"}}>로그인</h3>
            </div>
            <h2 className={cx('welcomemsg')}>HSG 인트라넷에 오신 것을 <br />환영합니다.</h2>
            <Form form={form} onFinish={() => {}} style={{ width: '100%' }} requiredMark={false}>
              <Form.Item name="id">
                <Input prefix={<UserOutlined/>} autoComplete="off" placeholder='아이디를 입력하세요' />
              </Form.Item>
              <Form.Item name="pw">
                <Input prefix={<LockOutlined/>} type="password" placeholder='비밀번호를 입력하세요' />
              </Form.Item>
              <Form.Item style={{ marginTop: "30px" }} shouldUpdate>
                {() => (
                  <Button htmlType="submit" type="primary" onClick={onClickLogin} disabled={!formValidation(form, [])} style={{width: "100%"}}>
                    로그인
                  </Button>
                )}
              </Form.Item>
            </Form>
            <div className={cx('autologin')}>
                <Checkbox style={{fontSize:"12px"}}>자동로그인</Checkbox>
                <div>
                  <a href="/auth/forgot_password">비밀번호 찾기</a> | <a href="/auth/register">사용자등록</a>
                </div>
            </div> 
            { /* 
            <div style={{marginTop:"20px", display: "flex", justifyContent: "space-between"}}>
              <Button style={{width:"49%"}} icon={<img src='/assets/images/icon-google.png' style={{height:"16px", marginRight:"3px", top:"-2px", position:"relative"}} />}>구글로 간편이용</Button>
              <Button style={{width:"49%"}} href="/auth/register">사용자등록</Button>
              
            </div>   
            */ }        
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
